var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"info-meta",class:{ 'is-narrow': _vm.narrow }},[_vm._l((_vm.rows),function(row){return [_c('dt',{key:'k-' + row.key},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_c('dd',{key:'v-' + row.key},[_vm._v(_vm._s(row.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }